import api from 'common/api'

export const PARENTS_URL = '/api/student/parents'
export const PARENT_URL = (id) => `/api/student/parents/${id}`

const service = {
  getParents: () => api.get(PARENTS_URL),

  updateParent: (parentId, original, updated) => api.patch(PARENT_URL(parentId), original, updated),

  deleteParent: (parentId) => api.delete(PARENT_URL(parentId)),

  createParent: (parent, invite) => api.post(`/api/users?type=Parent&invite=${invite}`, parent),

  inviteParent: (parentId) => api.post(`/api/invite/${parentId}`),
}

export default service
